import React from 'react';
import { useTranslation} from 'react-i18next';
import '../hibuButton/hibuButton.scss';
import './hibuTooltip.scss';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

type TooltipProps = {
    tooltipKey?: string;
    tooltipLabel?: string;
    placement?: any;
    translate?: boolean;
    delay?: number | {show: number; hide: number};
    defaultShow?: boolean;
    children: Iterable<React.JSX.Element> | React.JSX.Element;
};

export const HibuTooltip = ({
    tooltipKey,
    tooltipLabel,
    placement,
    children,
    delay,
    translate = true,
    defaultShow = false,
}: TooltipProps) => {
    const {t} = useTranslation();
    const renderTooltip = () => (
        <Tooltip className="hibu-tooltip" id={'tooltip-' + tooltipKey}>
            {translate ? tooltipKey && t(tooltipKey) : tooltipKey}
            {tooltipLabel || ''}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            delay={delay || 0}
            placement={placement || 'top'}
            trigger={['hover', 'focus', 'click']}
            overlay={renderTooltip()}
            defaultShow={defaultShow}
        >
            <span>{children}</span>
        </OverlayTrigger>
    );
};
